
import styled from 'styled-components';
// will be open when we change from js to tsx
// type IEyeBrown = {
//   background?: string,
//   color?: string,
//   uppercase?: boolean,
// };
// export const StyledEyeBrown = styled.div<IEyeBrown>`
interface IStyledEyeBrowContainerProps{
  eyeBrownMinHeight: any
}
interface IStyledEyeBrowProps{
  backgroundColor: any, 
  textColor: any, 
  uppercase: any, 
  eyeBrownPosition: any, 
  eyeBrownWidth: any, 
  eyeBrowFontSize: any,
  eyeBrownMarginBottom: any,
  eyeBrownMarginRight: any,
  isHidden?: any,
  isIconFront?: any,
  padding?: string;
  height?: string | number;
  fontWeight?: string | number;
}

export const StyledEyeBrownContainer = styled.div<IStyledEyeBrowContainerProps>`
  ${({  eyeBrownMinHeight }) => `
    min-height: ${!!eyeBrownMinHeight?eyeBrownMinHeight : 'auto'};
    flex-basis: 100%;
  `}
`;

export const StyledEyeBrown = styled.div<IStyledEyeBrowProps>`
    ${({ theme, backgroundColor, textColor, uppercase, eyeBrownPosition, eyeBrownWidth, eyeBrowFontSize, eyeBrownMarginBottom, eyeBrownMarginRight, isHidden, isIconFront, padding, height, fontWeight }) => `
      background:${backgroundColor};
      display: flex;
      flex-direction: ${!isIconFront ? 'row-reverse': 'row'};
      align-items: center;
      justify-content: center;
      width: ${eyeBrownWidth?eyeBrownWidth:'fit-content'};
      height: ${`${height}` || `${theme.uptimeSpace[10]}px`};
      color: ${textColor};
      padding: ${padding || `${theme.uptimeSpace[1]}px ${theme.uptimeSpace[4]}px`}};
      font-size: ${eyeBrowFontSize?eyeBrowFontSize: `${theme.uptimeFontSizes.desktop.fz1}px`};
      font-weight: bold;
      text-transform: ${uppercase ? 'uppercase' : 'none'};
      letter-spacing: ${`.${theme.uptimeSpace[1]}px`};
      border-radius: ${theme.uptimeSpace[10]}px;
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
      font-style: normal;
      line-height: ${theme.uptimeLineHeights.desktop.lh2}px;
      position:${eyeBrownPosition?eyeBrownPosition:'unset'};
      margin-bottom: ${eyeBrownMarginBottom?`${eyeBrownMarginBottom}px`:'unset'};
      margin-right: ${eyeBrownMarginRight?`${eyeBrownMarginRight}px`:'unset'};
      visibility : ${isHidden ? 'hidden' : 'unset'};
      .eyebrowText {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        margin-right: ${!isIconFront? `${theme.uptimeSpace[4]}px`: 'unset'};
        padding-top: ${!!theme.uptimeFonts.primary ? (theme?.uptimeDynamicAlignCenter?.eyebrow?.paddingTop ?? 0) : 0};
        font-weight: ${fontWeight || 700};
      }
    `}
`;